/**
 * THURULIYA HERITAGE Anuradhapura — Site Configuration
 * Edit this file to update hotel content, contact details, and feature toggles.
 * All image URLs verified working.
 */

const ANURADHAPURA = {
  hero: "https://images.pexels.com/photos/13667939/pexels-photo-13667939.jpeg?_gl=1*6dl4tz*_ga*MTY0Mjc0ODU3OS4xNzc4NjA1Njc1*_ga_8JE65Q40S6*czE3Nzg2MDU2NzQkbzEkZzEkdDE3Nzg2MDU4MjAkajUzJGwwJGgw?auto=compress&cs=tinysrgb&w=2000",
  stupa_sunset: "https://images.pexels.com/photos/13667943/pexels-photo-13667943.jpeg?_gl=1*k46gg3*_ga*MTY0Mjc0ODU3OS4xNzc4NjA1Njc1*_ga_8JE65Q40S6*czE3Nzg2MDU2NzQkbzEkZzEkdDE3Nzg2MDU5NTQkajU5JGwwJGgw?auto=compress&cs=tinysrgb&w=2000",
  sri_maha_bodhi: "https://tropicallifedambulla.com/wp-content/uploads/2019/07/jayasrimahabodi2.jpg?auto=compress&cs=tinysrgb&w=2000",
  ruwanwelisaya: "https://images.pexels.com/photos/13667949/pexels-photo-13667949.jpeg?auto=compress&cs=tinysrgb&w=2000",
  jetavanaramaya: "https://images.pexels.com/photos/13782478/pexels-photo-13782478.jpeg?auto=compress&cs=tinysrgb&w=2000",
  moonstone: "https://images.pexels.com/photos/2403568/pexels-photo-2403568.jpeg?auto=compress&cs=tinysrgb&w=1600",
  ancient_pillars: "https://images.unsplash.com/photo-1578469645742-46cae010e5d4?auto=format&fit=crop&q=80&w=1600",
  garden: "https://images.pexels.com/photos/2474690/pexels-photo-2474690.jpeg?auto=compress&cs=tinysrgb&w=1600",
  monk_walking: "https://images.pexels.com/photos/2480807/pexels-photo-2480807.jpeg?auto=compress&cs=tinysrgb&w=1600",
  sri_lanka_temple: "https://images.unsplash.com/photo-1565967511849-76a60a516170?auto=format&fit=crop&q=80&w=2000",
  hotel_exterior: "https://images.unsplash.com/photo-1568084680786-a84f91d1153c?auto=format&fit=crop&q=80&w=1600",
   about1: "../img/about1.jpeg",
};

export const siteConfig = {
  hotel: {
    name: "THURULIYA HERITAGE",
    location: "Anuradhapura",
    tagline: "Elegance in Every Stay",
    greeting: "ආයුබෝවන්",
    greetingTrans: "Ayubowan",
    shortDescription:
      "A serene heritage retreat in the sacred city of Anuradhapura — where timeless Sri Lankan hospitality meets refined modern comfort.",
    logoUrl:
      "https://customer-assets.emergentagent.com/job_1432d80a-f21b-41d6-a283-bb043c4da547/artifacts/gwm7nxfu_thuruliya_logo_no_background.png",
  },

  heritage: ANURADHAPURA,

  ANURADHAPURA : {
  hero: "https://images.pexels.com/photos/13667939/pexels-photo-13667939.jpeg?_gl=1*6dl4tz*_ga*MTY0Mjc0ODU3OS4xNzc4NjA1Njc1*_ga_8JE65Q40S6*czE3Nzg2MDU2NzQkbzEkZzEkdDE3Nzg2MDU4MjAkajUzJGwwJGgw?auto=compress&cs=tinysrgb&w=2000",
  stupa_sunset: "https://images.pexels.com/photos/13667943/pexels-photo-13667943.jpeg?_gl=1*k46gg3*_ga*MTY0Mjc0ODU3OS4xNzc4NjA1Njc1*_ga_8JE65Q40S6*czE3Nzg2MDU2NzQkbzEkZzEkdDE3Nzg2MDU5NTQkajU5JGwwJGgw?auto=compress&cs=tinysrgb&w=2000",
  sri_maha_bodhi: "https://tropicallifedambulla.com/wp-content/uploads/2019/07/jayasrimahabodi2.jpg?auto=compress&cs=tinysrgb&w=2000",
  ruwanwelisaya: "https://images.pexels.com/photos/13667949/pexels-photo-13667949.jpeg?auto=compress&cs=tinysrgb&w=2000",
  jetavanaramaya: "https://images.pexels.com/photos/13782478/pexels-photo-13782478.jpeg?auto=compress&cs=tinysrgb&w=2000",
  moonstone: "https://images.pexels.com/photos/2403568/pexels-photo-2403568.jpeg?auto=compress&cs=tinysrgb&w=1600",
  ancient_pillars: "https://images.unsplash.com/photo-1578469645742-46cae010e5d4?auto=format&fit=crop&q=80&w=1600",
  garden: "https://images.pexels.com/photos/2474690/pexels-photo-2474690.jpeg?auto=compress&cs=tinysrgb&w=1600",
  monk_walking: "https://images.pexels.com/photos/2480807/pexels-photo-2480807.jpeg?auto=compress&cs=tinysrgb&w=1600",
  sri_lanka_temple: "https://images.unsplash.com/photo-1565967511849-76a60a516170?auto=format&fit=crop&q=80&w=2000",
  hotel_exterior: "https://images.unsplash.com/photo-1568084680786-a84f91d1153c?auto=format&fit=crop&q=80&w=1600",
  about1: "../img/about1.jpeg",
  about2: "../img/about2.jpeg",
},

  contact: {
    phone: "+94 25 222 1828 / +94 70 599 4850 ",
    whatsapp: "94 70 774 6357",
    email: "thuruliyaheritage@gmail.com",
    address: "No 475, Kandy Road, Kurundankulama, Anuradapura, Sri Lanka",
    mapEmbedUrl:
      "https://www.google.com/maps?q=Anuradhapura,Sri+Lanka&output=embed",
    social: {
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
      tripadvisor: "https://tripadvisor.com",
    },
  },

  // External review platforms — set the property URLs here.
  reviewLinks: {
    google:
      "https://www.google.com/maps/search/?api=1&query=Thuruliya+Heritage+Anuradhapura",
    agoda: "https://www.agoda.com",
    tripadvisor: "https://www.tripadvisor.com",
  },

  bookingLinks: {
    bookingCom: "https://www.booking.com",
    agoda: "https://www.agoda.com/thuruliya-heritage-anuradhapura/hotel/anuradhapura-lk.html?countryId=82&finalPriceView=1&isShowMobileAppPrice=false&cid=1922893&numberOfBedrooms=&familyMode=false&adults=1&children=0&rooms=1&maxRooms=0&checkIn=2026-08-23&isCalendarCallout=false&childAges=&numberOfGuest=0&missingChildAges=false&travellerType=0&showReviewSubmissionEntry=false&currencyCode=LKR&isFreeOccSearch=false&tag=e8270226-244d-4884-85d9-8fe4141dae0b&flightSearchCriteria=[object%20Object]&los=5&searchrequestid=795baa13-cc2f-4523-a578-b7ddfb7ec520",
  },

  whatsappDefaultMessage:
    "Hello THURULIYA HERITAGE, I would like to check room availability and booking details.",

  features: {
    showRooms: true,
    showRestaurantBar: false,
    showFacilities: true,
    showGallery: true,
    showOffers: false,
    showReviews: false,
    showInquiryForm: true,
    showNearby: true,
    underConstructionMode: false,
    showSplash: true,
  },

  bookingChannels: {
    showBookingCom: false,
    showAgoda: true,
    showWhatsApp: true,
    showInquiry: true,
  },

  music: {
    src: "https://cdn.pixabay.com/download/audio/2022/05/27/audio_1808fbf07a.mp3?filename=meditationspiritual-moods-calm-2-176252.mp3",
    label: "Ambient Calm",
    volume: 0.2,
  },

  rooms: [
    {
      id: "family", name: "Family Room", shortDescription: "A spacious and comfortable family room designed to accommodate up to four guests, with air conditioning, free Wi-Fi, and convenient in-room amenities.", longDescription: "Our Family Room offers a comfortable and relaxing stay for families or small groups of up to four guests. The room includes air conditioning, free Wi-Fi, tea-making facilities with hot water, and a private en-suite bathroom. Guests can also order delicious meals from our food menu and enjoy beverages from the on-site bar.", capacity: "Up to 4 Guests", bed: "Family Bedding", view: "Garden View", images: ["../img/RoomA2.jpeg", "../img/RoomA4.jpeg", "../img/RoomA3.jpeg", "../img/RoomA5.jpeg",], facilities: ["Accommodates Up to 4 Guests", "Air Conditioning", "Free Wi-Fi", "Private En-suite Bathroom", "Tea-Making Facilities", "Hot Water", "Food Menu Available", "On-site Bar", "Daily Housekeeping",], priceNote: "Contact us for pricing",
    },
    {
      id: "family2", name: "Family Room", shortDescription: "A spacious and comfortable family room designed to accommodate up to four guests, with air conditioning, free Wi-Fi, and convenient in-room amenities.", longDescription: "Our Family Room offers a comfortable and relaxing stay for families or small groups of up to four guests. The room includes air conditioning, free Wi-Fi, tea-making facilities with hot water, and a private en-suite bathroom. Guests can also order delicious meals from our food menu and enjoy beverages from the on-site bar.", capacity: "Up to 4 Guests", bed: "Family Bedding", view: "Garden View", images: ["../img/RoomB1.jpeg", "../img/RoomB2.jpeg", "../img/RoomB3.jpeg", "../img/RoomB4.jpeg",], facilities: ["Accommodates Up to 4 Guests", "Air Conditioning", "Free Wi-Fi", "Private En-suite Bathroom", "Tea-Making Facilities", "Hot Water", "Food Menu Available", "On-site Bar", "Daily Housekeeping",], priceNote: "Contact us for pricing",
    },
    {
      id: "double2", name: "Double Room", shortDescription: "A comfortable and relaxing double room designed for up to two guests, with air conditioning, free Wi-Fi, and convenient in-room amenities.", longDescription: "Our Double Room provides a comfortable and relaxing stay for couples or two guests. The room includes air conditioning, free Wi-Fi, tea-making facilities with hot water, and a private en-suite bathroom. Guests can also order delicious meals from our food menu and enjoy beverages from the on-site bar.", capacity: "Up to 2 Guests", bed: "Double Bed", view: "Garden View", images: ["../img/RoomC1.jpeg", "../img/RoomC2.jpeg", "../img/RoomC3.jpeg", "../img/RoomC4.jpeg",], facilities: ["Accommodates Up to 2 Guests", "Double Bed", "Air Conditioning", "Free Wi-Fi", "Private En-suite Bathroom", "Tea-Making Facilities", "Hot Water", "Food Menu Available", "On-site Bar", "Daily Housekeeping",], priceNote: "Contact us for pricing",
    },
   
    // {
    //   id: "standard",
    //   name: "Standard Room",
    //   shortDescription:
    //     "Quietly elegant rooms with everything you need for a restful, comfortable stay.",
    //   longDescription:
    //     "Our Standard Rooms offer everything a traveller needs — restful queen bedding, modern amenities and that signature Sri Lankan warmth.",
    //   size: "24 m²",
    //   bed: "Queen Bed",
    //   view: "Courtyard View",
    //   images: [
    //     "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&q=80&w=1600",
    //     "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?auto=format&fit=crop&q=80&w=1600",
    //     "https://images.unsplash.com/photo-1576675784201-0e142b423952?auto=format&fit=crop&q=80&w=1600",
    //     "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?auto=format&fit=crop&q=80&w=1600",
    //   ],
    //   facilities: ["Queen Bed", "Air Conditioning", "Free Wi-Fi", "Hot Water", "Daily Housekeeping", "Work Desk", "Smart TV"],
    //   priceNote: "Contact for price",
    // },
  ],

  // Combined Restaurant & Bar
  restaurantBar: {
    title: "The Heritage Table & Moonstone Bar",
    description:
      "One destination for every mood — from sunrise breakfasts and authentic Sri Lankan classics to candlelit dinners and crafted cocktails beneath the stars of Anuradhapura.",
    images: {
      hero: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&q=80&w=2000",
      food: "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?auto=format&fit=crop&q=80&w=1600",
      bar: "https://images.pexels.com/photos/19689233/pexels-photo-19689233.jpeg?auto=compress&cs=tinysrgb&w=2000",
      plated: "https://images.pexels.com/photos/32978236/pexels-photo-32978236.jpeg?auto=compress&cs=tinysrgb&w=1600",
    },
    restaurant: {
      title: "The Heritage Table",
      tagline: "Where every meal tells a story",
      offerings: ["Breakfast", "Lunch", "Dinner", "Sri Lankan Dishes", "Western Cuisine", "Seafood", "Desserts", "Room Service"],
    },
    bar: {
      title: "The Moonstone Bar",
      tagline: "Evenings beneath the stars",
      offerings: ["Signature Cocktails", "Mocktails", "Craft Beer", "Fine Wine", "Premium Spirits", "Bar Snacks"],
    },
  },

  // Nearby destinations (sacred sites + attractions in Anuradhapura)
  nearbyDestinations: [
    {
      id: "ruwanwelisaya",
      name: "Ruwanwelisaya",
      distance: "5 min drive",
      description:
        "The radiant white stupa built by King Dutugemunu — one of Sri Lanka's most sacred Buddhist monuments.",
      image: "https://images.pexels.com/photos/10638034/pexels-photo-10638034.jpeg?auto=compress&cs=tinysrgb&w=1600",
      tag: "UNESCO Heritage",
    },
    {
      id: "sri-maha-bodhi",
      name: "Sri Maha Bodhi",
      distance: "8 min drive",
      description:
        "The oldest historically authenticated tree in the world — over 2,300 years of living heritage.",
      image: "https://tropicallifedambulla.com/wp-content/uploads/2019/07/jayasrimaha-bodhi.jpg?auto=compress&cs=tinysrgb&w=1600",
      tag: "Sacred Tree",
    },
    {
      id: "jetavanaramaya",
      name: "Jetavanaramaya",
      distance: "10 min drive",
      description:
        "Once the tallest stupa in the ancient world, this colossal brick monument still inspires awe.",
      image: "https://images.pexels.com/photos/6840389/pexels-photo-6840389.jpeg?auto=compress&cs=tinysrgb&w=1600",
      tag: "Ancient Wonder",
    },
    {
      id: "isurumuniya",
      name: "Isurumuniya Vihara",
      distance: "12 min drive",
      description:
        "A rock temple famed for the romantic stone carving of Isurumuniya Lovers and serene lily ponds.",
      image: "https://www.tourslanka.com/wp-content/uploads/2018/06/Isurumuniya-Viharaya.jpg?auto=format&fit=crop&q=80&w=1600",
      tag: "Rock Temple",
    },
    {
      id: "mihintale",
      name: "Mihintale",
      distance: "20 min drive",
      description:
        "The birthplace of Buddhism in Sri Lanka — climb 1,840 stone steps to ancient summits at dawn.",
      image: "https://i0.wp.com/amazinglanka.com/wp/wp-content/uploads/2013/10/9428368750_6406e23e02_o.jpg?resize=640%2C480&ssl=1?auto=compress&cs=tinysrgb&w=1600",
      tag: "Pilgrim Trail",
    },
    {
      id: "twin-ponds",
      name: "Kuttam Pokuna",
      distance: "7 min drive",
      description:
        "The famous Twin Ponds — a masterpiece of ancient hydraulic engineering and elegant geometry.",
      image: "https://d37rmf1ynyg9aw.cloudfront.net/fit-in/1280x1280/data/v4/resources/images/57189927-5d00-4171-8802-81b707fee25a.jpg?auto=compress&cs=tinysrgb&w=1600",
      tag: "Ancient Engineering",
    },
  ],

  facilities: [
    { id: "wifi", label: "Free Wi-Fi", icon: "Wifi", show: true },
    { id: "parking", label: "Parking", icon: "Car", show: true },
    { id: "restaurant", label: "Restaurant", icon: "UtensilsCrossed", show: true },
    { id: "bar", label: "Bar", icon: "Wine", show: true },
    { id: "room-service", label: "Room Service", icon: "BellRing", show: true },
    { id: "ac", label: "Air Conditioning", icon: "Snowflake", show: true },
    { id: "hot-water", label: "Hot Water", icon: "Droplets", show: true },
    { id: "front-desk", label: "24/7 Front Desk", icon: "Clock", show: true },
  ],

  gallery: [
    { src: ANURADHAPURA.ruwanwelisaya, category: "heritage", alt: "Ruwanwelisaya Stupa", aspect: "tall" },
    { src: "https://images.pexels.com/photos/33713449/pexels-photo-33713449.jpeg?_gl=1*252usj*_ga*MTY0Mjc0ODU3OS4xNzc4NjA1Njc1*_ga_8JE65Q40S6*czE3NzkxMjkzMzckbzIkZzEkdDE3NzkxMjk0MDQkajUzJGwwJGgw?auto=compress&cs=tinysrgb&w=1200", category: "rooms", alt: "Deluxe Room" },
    { src: ANURADHAPURA.stupa_sunset, category: "heritage", alt: "Stupa at Sunset" },
    { src: "https://images.pexels.com/photos/29377381/pexels-photo-29377381.jpeg?auto=format&fit=crop&q=80&w=1200", category: "rooms", alt: "Family Room" },
    { src: "https://images.pexels.com/photos/13244651/pexels-photo-13244651.jpeg?auto=format&fit=crop&q=80&w=1200", category: "restaurant", alt: "Restaurant Interior", aspect: "tall" },
    { src: "https://images.pexels.com/photos/20264385/pexels-photo-20264385.jpeg?auto=format&fit=crop&q=80&w=1200", category: "food", alt: "Sri Lankan Cuisine" },
    { src: "https://images.pexels.com/photos/4871002/pexels-photo-4871002.jpeg?auto=compress&cs=tinysrgb&w=1200", category: "bar", alt: "Bar Lounge" },
    { src: "https://images.pexels.com/photos/33802253/pexels-photo-33802253.jpeg?auto=compress&cs=tinysrgb&w=1200", category: "rooms", alt: "Heritage Suite" },
    { src: "https://images.pexels.com/photos/37094774/pexels-photo-37094774.jpeg?auto=format&fit=crop&q=80&w=1200", category: "reception", alt: "Reception", aspect: "tall" },
    { src: "https://images.pexels.com/photos/32694729/pexels-photo-32694729.jpeg?auto=compress&cs=tinysrgb&w=1200", category: "food", alt: "Plated Dish" },
    { src: "https://images.pexels.com/photos/10472537/pexels-photo-10472537.jpeg?auto=format&fit=crop&q=80&w=1200", category: "food", alt: "Sri Lankan Cuisine" },
    { src: "https://images.pexels.com/photos/37278570/pexels-photo-37278570.jpeg?auto=compress&cs=tinysrgb&w=1200", category: "bar", alt: "Bar Lounge" },
    { src: "https://images.pexels.com/photos/4549640/pexels-photo-4549640.jpeg?auto=compress&cs=tinysrgb&w=1200", category: "rooms", alt: "Heritage Suite" },
    { src: "https://images.pexels.com/photos/31912675/pexels-photo-31912675.jpeg?auto=format&fit=crop&q=80&w=1200", category: "reception", alt: "Reception", aspect: "tall" },
    { src: "https://images.pexels.com/photos/8131234/pexels-photo-8131234.jpeg?auto=compress&cs=tinysrgb&w=1200", category: "food", alt: "Plated Dish" },
    { src: "https://images.pexels.com/photos/35606852/pexels-photo-35606852.jpeg?auto=compress&cs=tinysrgb&w=1200", category: "food", alt: "Plated Dish" },

  ],

  offers: [
    { id: "weekend", title: "Weekend Heritage Escape", description: "Two nights with daily breakfast, an evening high tea and a complimentary city heritage tour.", image: ANURADHAPURA.ruwanwelisaya },
    { id: "couple", title: "Couple's Retreat", description: "Romantic candlelit dinner, in-room flowers and a sunrise breakfast for two on the terrace.", image: "https://images.pexels.com/photos/13722872/pexels-photo-13722872.jpeg?auto=compress&cs=tinysrgb&w=1200" },
    { id: "family", title: "Family Package", description: "Connecting rooms, family-style meals and a curated cultural day for little explorers.", image: "https://images.unsplash.com/photo-1566665797739-1674de7a421a?auto=format&fit=crop&q=80&w=1200" },
    { id: "dining", title: "Heritage Dining Offer", description: "A six-course tasting menu featuring the finest of Sri Lankan and continental flavours.", image: "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?auto=format&fit=crop&q=80&w=1200" },
    { id: "happy-hour", title: "Moonstone Happy Hour", description: "Buy one get one on signature cocktails, every evening between 6 and 8 pm.", image: "https://images.pexels.com/photos/19689233/pexels-photo-19689233.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  ],

  // Reviews — each tagged with their source (Agoda / Google / TripAdvisor).
  // Configure reviewLinks above to point to your live property pages.
  reviews: [
    { name: "Anjali Perera", country: "Sri Lanka", rating: 5, source: "google", text: "An exquisite stay. The hospitality was warm, the food unforgettable and the rooms beautifully appointed. A true heritage experience." },
    { name: "James Whitfield", country: "United Kingdom", rating: 5, source: "agoda", text: "Perfect base for exploring Anuradhapura. The staff went above and beyond, and the evenings at the bar were magical." },
    { name: "Mei Lin", country: "Singapore", rating: 5, source: "google", text: "Elegant interiors, peaceful gardens and outstanding Sri Lankan cuisine. We will absolutely return." },
    { name: "Rafael Souza", country: "Portugal", rating: 4, source: "agoda", text: "Beautiful property steeped in culture. The Heritage Suite was a dream — quiet, luxurious and full of character." },
    { name: "Priya Iyer", country: "India", rating: 5, source: "tripadvisor", text: "From the moment we arrived, every detail felt thoughtful. The morning light over the gardens is something we still talk about." },
    { name: "Tomás García", country: "Spain", rating: 5, source: "google", text: "Genuinely warm hospitality. The chef prepared a personalised menu for our anniversary — unforgettable." },
  ],

  reviewStats: {
    google: { rating: 4.8, count: 412 },
    agoda: { rating: 9.2, count: 286 },
    tripadvisor: { rating: 4.9, count: 174 },
  },

  about: {
    title: "A Sanctuary of Heritage & Hospitality",
    paragraphs: [
      "Nestled in the heart of Anuradhapura, Sri Lanka's ancient sacred city THURULIYA HERITAGE is a quiet celebration of the island's timeless soul. Our boutique retreat blends centuries-old craftsmanship with refined modern comfort.",
      "From the moment you arrive, you'll be welcomed by warm Sri Lankan hospitality, peaceful tropical gardens and rooms appointed with care. Whether you've come to explore the dagobas at dawn, savour our chef's heritage table, or simply unwind by the bar, every detail is crafted for your comfort.",
    ],
  },
};

export default siteConfig;
